import axios from '@/libs/api.request'

// 获取更新包列表
export const getUpdatePackageList = (params) => {
  return axios.request({ url: '/m_api/update-package/list', method: 'get', params })
}

// 创建更新包
export const createUpdatePackage = (data) => {
  return axios.request({ url: '/m_api/update-package/list', method: 'post', data })
}

// 编辑更新包
export const editUpdatePackage = (data) => {
  return axios.request({ url: '/m_api/update-package/edit', method: 'put', data })
}

// 删除更新包
export const deleteUpdatePackage = (data) => {
  return axios.request({ url: '/m_api/update-package/delete', method: 'post', data })
}

// 上传更新包文件（使用通用上传接口）
export const uploadUpdatePackage = (formData) => {
  return axios.request({
    url: '/v1/sysparameter/upload',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 批量更新
export const batchUpdatePackage = (data) => {
  return axios.request({ url: '/m_api/update-package/batch', method: 'post', data })
}